import {
  BookText,
  CircleSlash,
  Cog,
  GraduationCap,
  Inbox,
  LayoutDashboard,
  MessageSquare,
  ScrollText,
  ShieldCheck,
  SlidersHorizontal,
  Users,
  type LucideIcon,
} from "lucide-react";

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  description?: string;
}

export interface NavSection {
  label: string;
  items: NavItem[];
}

export const navSections: NavSection[] = [
  {
    label: "Operate",
    items: [
      { to: "/", label: "Dashboard", icon: LayoutDashboard, description: "Today at a glance" },
      { to: "/leads", label: "Leads", icon: Users, description: "Triage incoming students" },
      { to: "/handoffs", label: "Handoffs", icon: Inbox, description: "Pending manual review" },
      { to: "/chat", label: "Chat tester", icon: MessageSquare, description: "Run prompts against the bot" },
    ],
  },
  {
    label: "Catalog",
    items: [
      { to: "/courses", label: "Courses", icon: GraduationCap },
      { to: "/groups", label: "Groups", icon: Users },
    ],
  },
  {
    label: "Behavior",
    items: [
      { to: "/rules", label: "Placement rules", icon: CircleSlash },
      { to: "/knowledge", label: "Knowledge", icon: BookText },
      { to: "/instructions", label: "Instructions", icon: ScrollText },
    ],
  },
  {
    label: "Settings",
    items: [
      { to: "/config", label: "Config", icon: SlidersHorizontal },
      { to: "/admins", label: "Admins", icon: ShieldCheck },
      { to: "/preferences", label: "Preferences", icon: Cog },
    ],
  },
];
